<template>
  <v-row class="text-left full-height">
    <v-col cols="12">
      <v-card class="rounded-lg pa-4">
        <Typography variant="h-2" class="pb-2">Customization</Typography>
        <!-- <v-card-title class="font-weight-bold">Customization</v-card-title> -->
        <v-tabs v-model="tab" color="brandPrimary">
          <v-tab key="programDashboard" v-if="showProgramPageTab">Program Dashboard</v-tab>
          <v-tab key="signUp" v-if="showSignUpTab">Sign Up</v-tab>
          <v-tab key="navigation">Program Setup</v-tab>
          <v-tab key="presets" v-if="showPresetTab">Reward Setup</v-tab>
          <v-tab key="colors">Colors</v-tab>
          <v-tab key="reporting">Reporting</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="programDashboard" v-if="showProgramPageTab">
            <ProgramDashboardManager :client="client" @getClient="handleComponentSave" />
          </v-tab-item>
          <v-tab-item key="signUp" v-if="showSignUpTab">
            <SignUpManager :client="client" @getClient="handleComponentSave" />
          </v-tab-item>
          <v-tab-item key="navigation">
            <ProgramSetupManager :client="client" @getClient="handleComponentSave" />
          </v-tab-item>
          <v-tab-item key="presets" v-if="showPresetTab">
            <PresetManager :client="client" @getClient="handleComponentSave" />
          </v-tab-item>
          <v-tab-item key="colors">
            <ColorManager :client="client" @getClient="handleComponentSave" />
          </v-tab-item>
          <v-tab-item key="reporting">
            <ClientReportingManager :client="client" @getClient="handleComponentSave" />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// Components
import Typography from "@/components/generic/Typography.vue";
import PresetManager from "@/components/account-management/PaymentPresets.vue";
import ColorManager from "@/components/account-management/ClientColorManager.vue";
import ClientReportingManager from "@/components/account-management/ClientReportingManager.vue";
import ProgramDashboardManager from "@/components/account-management/ProgramDashboardManager.vue";
import SignUpManager from "@/components/account-management/SignUpManager.vue";
import ProgramSetupManager from "@/components/account-management/ProgramSetupManager.vue";

import { mapState } from "vuex";

export default {
  name: "CompanyCustomization",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      required: false,
    },
  },
  components: {
    PresetManager,
    ColorManager,
    ClientReportingManager,
    ProgramDashboardManager,
    SignUpManager,
    ProgramSetupManager,
    Typography,
  },
  data() {
    return {
      tab: null,
    };
  },
  methods: {
    handleComponentSave(props) {
      this.$emit("getClient", props);
    },
  },
  computed: {
    ...mapState(["userProfile", "roles"]),
    showSignUpTab() {
      return this.roles && this.roles.includes("40ClientAdminV2");
    },
    showPresetTab() {
      return (
        this.roles &&
        (this.roles.includes("40ClientAdminV2") || this.roles.includes("30FinanceAdminV2"))
      );
    },
    showProgramPageTab() {
      return (
        this.roles?.includes("40ClientAdminV2") &&
        (this.userProfile?.Client?.displayProgramDashboardPage ||
          this.client?.displayProgramDashboardPage)
      );
    },
  },
};
</script>

<style scoped></style>
